import React, {useState, useEffect} from "react";
import {Tab, Nav} from "react-bootstrap";
import "./style.css";

import Chapter1 from "./Chapter-1";
import Chapter2 from "./Chapter-2";
import Chapter3 from "./Chapter-3";
import Chapter4 from "./Chapter-4";
import Chapter5 from "./Chapter-5";
import Chapter6 from "./Chapter-6";
import Chapter7 from "./Chapter-7";
import Chapter8 from "./Chapter-8";
import Chapter9 from "./Chapter-9";
import Chapter10 from "./Chapter-10";
import Chapter11 from "./Chapter-11";
import Chapter12 from "./Chapter-12";
import Chapter13 from "./Chapter-13";
import Chapter14 from "./Chapter-14";
import Chapter15 from "./Chapter-15";
import Chapter16 from "./Chapter-16";
import Chapter17 from "./Chapter-17";
import Chapter18 from "./Chapter-18";
import Chapter19 from "./Chapter-19";
import Chapter20 from "./Chapter-20";
import Chapter21 from "./Chapter-21";
import Chapter22 from "./Chapter-22";
import Chapter23 from "./Chapter-23";
import Chapter24 from "./Chapter-24";
import Chapter25 from "./Chapter-25";
import Chapter26 from "./Chapter-26";
import Chapter27 from "./Chapter-27";
import Chapter28 from "./Chapter-28";
import Chapter29 from "./Chapter-29";
import Chapter30 from "./Chapter-30";
import Chapter31 from "./Chapter-31";
import Chapter32 from "./Chapter-32";
import Chapter33 from "./Chapter-33";
import Chapter34 from "./Chapter-34";
import Chapter35 from "./Chapter-35";
import { useSelector } from "react-redux";

// Move data constants OUTSIDE the component
const SinhalaData = [
    {key: 1, title: "රියදුරන් මගමරුවන් බවට පත් කරන සාධක", subtitle: "", readTime: "5 min"},
    {key: 2, title: "මහමග ත්‍රස්තවාදය මැඩලිය නොහැකිද? හැකි ය", subtitle: "", readTime: "4 min"},
    {key: 3, title: " මහමග අනතුරු ගෙන එන නිරතුරු – රියදුරු විඩාව", subtitle: "", readTime: "6 min"},
    {key: 4, title: " මහපාරේ යකා නටන්නෝ හෙවත් ආක්‍රමණශීලී රියදුරන් – මාර්ග වියරුව", subtitle: "", readTime: "5 min"},
    {key: 5, title: " සොහොන් පිටියට පාර කියන යක්ෂයා – මත්ද්‍රව්‍ය", subtitle: "", readTime: "7 min"},
    {key: 6, title: "  නීත්‍යානුකූල රියදුරෙකු බවට පත්වීම හා රියදුරු බලපත්‍රය ලබා ගැනීම", subtitle: "", readTime: "8 min"},
    {key: 7, title: "  රියදුරු අභිවෘද්ධි ලකුණු", subtitle: "", readTime: "4 min"},
    {key: 8, title: "   රිය අනතුරකදී ඔබේ වගකීම", subtitle: "", readTime: "6 min"},
    {key: 9, title: "  වාහන සිහිනය ජය ගන්න පහසු මගක් – ලීසිං", subtitle: "", readTime: "5 min"},
    {key: 10, title: "  අධිවේගී මාර්ගයේදී වැදගත් කරුණු", subtitle: "", readTime: "7 min"},
    {key: 11, title: "  පදිකයන් සඳහා අදාළ මාර්ග නීති රීති", subtitle: "", readTime: "5 min"},
    {key: 12, title: "  පා පැදිකරුවන් සඳහා වැදගත් නීති", subtitle: "", readTime: "4 min"},
    {key: 13, title: "   මෝටර් වාහන පදවන්නන් සඳහා වැදගත් කරුණු", subtitle: "", readTime: "6 min"},
    {key: 14, title: "  ධාවන තීරු පිළිබඳ නීති", subtitle: "", readTime: "5 min"},
    {key: 15, title: "  මංසන්ධි හරහා ධාවනය කිරීම", subtitle: "", readTime: "6 min"},
    {key: 16, title: " ආලෝක සංඥා", subtitle: "", readTime: "4 min"},
    {key: 17, title: " පොලිස් හස්ත සංඥා", subtitle: "", readTime: "4 min"},
    {key: 18, title: " වටරවුමකදී ධාවනය", subtitle: "", readTime: "5 min"},
    {key: 19, title: " මංසන්ධි කොටුව", subtitle: "", readTime: "4 min"},
    {key: 20, title: "  වාහන නතර කිරීම", subtitle: "", readTime: "5 min"},
    {key: 21, title: "  වාහන නතර කර තැබීම තහනම් ස්ථාන", subtitle: "", readTime: "5 min"},
    {key: 22, title: "  මාර්ග සංඥා", subtitle: "", readTime: "8 min"},
    {key: 23, title: "  මාර්ගය මත පිහිටුවන සංඥා", subtitle: "", readTime: "6 min"},
    {key: 24, title: "   අනතුරකදී හෝ ආපදා අවස්ථාවකදී ගත යුතු පියවර", subtitle: "", readTime: "7 min"},
    {key: 25, title: "  රියදුරන් සඳහා වැදගත් සාමාන්‍ය කාර්මික දැනුම", subtitle: "", readTime: "9 min"},
    {key: 26, title: "  සිසිලන පද්ධතිය", subtitle: "", readTime: "6 min"},
    {key: 27, title: " ගියර් පෙට්ටිය", subtitle: "", readTime: "7 min"},
    {key: 28, title: "  රෝධක හෙවත් තිරිංග", subtitle: "", readTime: "6 min"},
    {key: 29, title: "  සුක්කානම", subtitle: "", readTime: "5 min"},
    {key: 30, title: "  බැටරිය", subtitle: "", readTime: "6 min"},
    {key: 31, title: " එළවුම් ක්‍රම", subtitle: "", readTime: "7 min"},
    {key: 32, title: " ටයර්", subtitle: "", readTime: "6 min"},
    {key: 33, title: " ඩෑෂ් බෝඩ් සංඥා", subtitle: "", readTime: "5 min"},
    {key: 34, title: " රියදුරන් රඳවා ගැනීම", subtitle: "", readTime: "5 min"},
    {key: 35, title: " රථවාහන නඩත්තුව", subtitle: "", readTime: "8 min"},
];

const EnglishData = [
    { key: 1, title: " Factors That Turn Drivers into Road Offenders", subtitle: "", readTime: "5 min" },
    { key: 2, title: " Can Road Terrorism Be Controlled? Yes, It Can", subtitle: "", readTime: "4 min" },
    { key: 3, title: " A Constant Cause of Road Accidents – Driver Fatigue", subtitle: "", readTime: "6 min" },
    { key: 4, title: " Aggressive Drivers on the Road – Road Rage", subtitle: "", readTime: "5 min" },
    { key: 5, title: " The Demon That Leads to the Graveyard – Drugs", subtitle: "", readTime: "7 min" },
    { key: 6, title: " Becoming a Legal Driver and Obtaining a Driving License", subtitle: "", readTime: "8 min" },
    { key: 7, title: " Driver Development Points", subtitle: "", readTime: "4 min" },
    { key: 8, title: " Your Responsibility in a Road Accident", subtitle: "", readTime: "6 min" },
    { key: 9, title: " An Easy Way to Achieve the Vehicle Dream – Leasing", subtitle: "", readTime: "5 min" },
    { key: 10, title: " Important Points When Driving on the Expressway", subtitle: "", readTime: "7 min" },
    { key: 11, title: " Road Rules Relevant to Pedestrians", subtitle: "", readTime: "5 min" },
    { key: 12, title: " Important Rules for Cyclists", subtitle: "", readTime: "4 min" },
    { key: 13, title: " Important Guidelines for Motor Vehicle Drivers", subtitle: "", readTime: "6 min" },
    { key: 14, title: " Rules Related to Traffic Lanes", subtitle: "", readTime: "5 min" },
    { key: 15, title: " Driving Through Intersections", subtitle: "", readTime: "6 min" },
    { key: 16, title: " Traffic Light Signals", subtitle: "", readTime: "4 min" },
    { key: 17, title: " Police Hand Signals", subtitle: "", readTime: "4 min" },
    { key: 18, title: " Driving at Roundabouts", subtitle: "", readTime: "5 min" },
    { key: 19, title: " Intersection Box (Box Junction)", subtitle: "", readTime: "4 min" },
    { key: 20, title: " Stopping Vehicles", subtitle: "", readTime: "5 min" },
    { key: 21, title: " Places Where Parking is Prohibited", subtitle: "", readTime: "5 min" },
    { key: 22, title: " Road Signs", subtitle: "", readTime: "8 min" },
    { key: 23, title: " Signs Placed on the Road Surface", subtitle: "", readTime: "6 min" },
    { key: 24, title: " Steps to Take in an Accident or Emergency Situation", subtitle: "", readTime: "7 min" },
    { key: 25, title: " Important General Mechanical Knowledge for Drivers", subtitle: "", readTime: "9 min" },
    { key: 26, title: " Cooling System", subtitle: "", readTime: "6 min" },
    { key: 27, title: " Gearbox", subtitle: "", readTime: "7 min" },
    { key: 28, title: " Braking System (Brakes)", subtitle: "", readTime: "6 min" },
    { key: 29, title: " Steering System", subtitle: "", readTime: "5 min" },
    { key: 30, title: " Battery", subtitle: "", readTime: "6 min" },
    { key: 31, title: " Transmission System", subtitle: "", readTime: "7 min" },
    { key: 32, title: " Tyres", subtitle: "", readTime: "6 min" },
    { key: 33, title: " Dashboard Indicators", subtitle: "", readTime: "5 min" },
    { key: 34, title: " Driver Retention and Control", subtitle: "", readTime: "5 min" },
    { key: 35, title: " Vehicle Maintenance", subtitle: "", readTime: "8 min" },
];

const TamilData = [
    { key: 1, title: " ஓட்டுநர்களை சாலை குற்றவாளிகளாக மாற்றும் காரணிகள்", subtitle: "", readTime: "5 min" },
    { key: 2, title: "நெடுஞ்சாலை பயங்கரவாதத்தை கட்டுப்படுத்த முடியாதா? முடியும்", subtitle: "", readTime: "4 min" },
    { key: 3, title: " நெடுஞ்சாலை விபத்துகளுக்குக் காரணமான தொடர்ச்சியான அபாயம் – ஓட்டுநர் சோர்வு", subtitle: "", readTime: "6 min" },
    { key: 4, title: " சாலையில் ஆவேசமாக நடக்கும் ஓட்டுநர்கள் – சாலை கோபம்", subtitle: "", readTime: "5 min" },
    { key: 5, title: " கல்லறைக்கு வழிகாட்டும் தீய சக்தி – போதைப்பொருட்கள்", subtitle: "", readTime: "7 min" },
    { key: 6, title: " சட்டபூர்வ ஓட்டுநராக மாறுதல் மற்றும் ஓட்டுநர் உரிமம் பெறுதல்", subtitle: "", readTime: "8 min" },
    { key: 7, title: " ஓட்டுநர் அபிவிருத்தி மதிப்பெண்கள்", subtitle: "", readTime: "4 min" },
    { key: 8, title: " விபத்து நேரத்தில் உங்கள் பொறுப்புகள்", subtitle: "", readTime: "6 min" },
    { key: 9, title: " வாகன கனவைக் நிறைவேற்ற எளிய வழி – லீசிங்", subtitle: "", readTime: "5 min" },
    { key: 10, title: " அதிவேக நெடுஞ்சாலையில் கவனிக்க வேண்டிய முக்கிய அம்சங்கள்", subtitle: "", readTime: "7 min" },
    { key: 11, title: " நடைபயணிகளுக்கான போக்குவரத்து விதிகள்", subtitle: "", readTime: "5 min" },
    { key: 12, title: " மிதிவண்டி ஓட்டுநர்களுக்கான முக்கிய விதிகள்", subtitle: "", readTime: "4 min" },
    { key: 13, title: " மோட்டார் வாகன ஓட்டுநர்களுக்கான முக்கிய குறிப்புகள்", subtitle: "", readTime: "6 min" },
    { key: 14, title: " பாதை (லேன்) தொடர்பான விதிமுறைகள்", subtitle: "", readTime: "5 min" },
    { key: 15, title: " சந்திப்புகள் வழியாக வாகனம் ஓட்டுதல்", subtitle: "", readTime: "6 min" },
    { key: 16, title: " ஒளி சிக்னல்கள்", subtitle: "", readTime: "4 min" },
    { key: 17, title: " காவல் கை சிக்னல்கள்", subtitle: "", readTime: "4 min" },
    { key: 18, title: " வட்டச் சந்திப்பில் ஓட்டுதல்", subtitle: "", readTime: "5 min" },
    { key: 19, title: " சந்திப்பு பெட்டி", subtitle: "", readTime: "4 min" },
    { key: 20, title: " வாகனம் நிறுத்துதல்", subtitle: "", readTime: "5 min" },
    { key: 21, title: " வாகனம் நிறுத்தத் தடை செய்யப்பட்ட இடங்கள்", subtitle: "", readTime: "5 min" },
    { key: 22, title: " சாலை சின்னங்கள்", subtitle: "", readTime: "8 min" },
    { key: 23, title: " சாலையில் அமைக்கப்படும் சின்னங்கள்", subtitle: "", readTime: "6 min" },
    { key: 24, title: " விபத்து அல்லது அவசர நிலை நேரத்தில் எடுக்க வேண்டிய நடவடிக்கைகள்", subtitle: "", readTime: "7 min" },
    { key: 25, title: " ஓட்டுநர்களுக்கான முக்கிய பொதுத் தொழில்நுட்ப அறிவு", subtitle: "", readTime: "9 min" },
    { key: 26, title: " குளிரூட்டும் அமைப்பு", subtitle: "", readTime: "6 min" },
    { key: 27, title: " கியர் பெட்டி", subtitle: "", readTime: "7 min" },
    { key: 28, title: " பிரேக் (திருத்தி) அமைப்பு", subtitle: "", readTime: "6 min" },
    { key: 29, title: " ஸ்டியரிங்", subtitle: "", readTime: "5 min" },
    { key: 30, title: " பேட்டரி", subtitle: "", readTime: "6 min" },
    { key: 31, title: " இயக்க அமைப்பு", subtitle: "", readTime: "7 min" },
    { key: 32, title: " டயர்கள்", subtitle: "", readTime: "6 min" },
    { key: 33, title: " டாஷ்போர்டு சின்னங்கள்", subtitle: "", readTime: "5 min" },
    { key: 34, title: " ஓட்டுநர் கட்டுப்பாடு மற்றும் பாதுகாப்பு", subtitle: "", readTime: "5 min" },
    { key: 35, title: " வாகன பராமரிப்பு", subtitle: "", readTime: "8 min" }
];

const SinhalaHandBook = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
    const [activeKey, setActiveKey] = useState(1);
    const [languageData, setLanguageData] = useState(SinhalaData);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [darkMode, setDarkMode] = useState(false);
    const [fontSize, setFontSize] = useState(16);
    const [searchQuery, setSearchQuery] = useState("");



      useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setSidebarOpen(false); // Close sidebar on mobile by default
            } else {
                setSidebarOpen(true); // Open sidebar on desktop
            }
        };

        // Set initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    
     
    useEffect(() => {
        switch (selectedLanguage?.value) {
            case "english":
                setLanguageData(EnglishData);
                break;
            case "tamil":
                setLanguageData(TamilData);
                break;
            case "sinhala":
            default:
                setLanguageData(SinhalaData);
        }
    }, [selectedLanguage]);

    // Handle tab selection - ensure it's always a number
    const handleSelect = (k) => {
        const numericKey = typeof k === 'string' ? parseInt(k, 10) : k;
        setActiveKey(numericKey);
        // Close sidebar on mobile after selection
        if (window.innerWidth <= 768) {
            setSidebarOpen(false);
        }
    };

    const filteredData = languageData.filter(item => 
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const progress = (activeKey / languageData.length) * 100;

    // Navigation handlers with proper number conversion
    const handlePrevious = () => {
        const currentKey = Number(activeKey);
        if (currentKey > 1) {
            setActiveKey(currentKey - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleNext = () => {
        const currentKey = Number(activeKey);
        if (currentKey < languageData.length) {
            setActiveKey(currentKey + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <div className={`handbook-container ${darkMode ? 'dark-mode' : ''}`}>
            {/* Reading Progress Bar */}
            <div className="reading-progress">
                <div className="progress-bar" style={{width: `${progress}%`}}></div>
            </div>

            {/* Top Control Bar */}
            <div className="control-bar">
                <button 
                    className="menu-toggle"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    aria-label="Toggle menu"
                >
                    <span className="hamburger-icon">☰</span>
                </button>
                
                <div className="controls">
                    {/* <button 
                        className="control-btn"
                        onClick={() => setDarkMode(!darkMode)}
                        title="Toggle dark mode"
                        aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
                    >
                        {darkMode ? '☀️' : '🌙'}
                    </button> */}
                </div>
            </div>

            <div className="handbook-wrapper">
                <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
                    <div className={`handbook-grid ${!sidebarOpen ? 'sidebar-closed' : ''}`}>
                        {/* Sidebar */}
                        <div className={`handbook-sidebar ${!sidebarOpen ? 'closed' : ''}`}>
                            <div className="sidebar-header">
                                <h2 className="sidebar-title">📚 Chapters</h2>
                                <div className="chapter-count">{languageData.length} Chapters</div>
                            </div>

                            <Nav variant="pills" className="chapter-nav">
                                {filteredData.map((item) => (
                                    <Nav.Item key={item.key}>
                                        <Nav.Link 
                                            eventKey={item.key} 
                                            className="chapter-link"
                                        >
                                            <div className="chapter-content">
                                                <div className="chapter-number">
                                                    {activeKey === item.key ? '📖' : item.key}
                                                </div>
                                                <div className="chapter-info">
                                                    <div className="chapter-title">{item.title}</div>
                                                </div>
                                            </div>
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </div>

                        {/* Content Area */}
                        <div className="handbook-content" style={{fontSize: `${fontSize}px`}}>
                            <Tab.Content className="chapter-content-wrapper">
                                <Tab.Pane eventKey={1}><Chapter1/></Tab.Pane>
                                <Tab.Pane eventKey={2}><Chapter2/></Tab.Pane>
                                <Tab.Pane eventKey={3}><Chapter3/></Tab.Pane>
                                <Tab.Pane eventKey={4}><Chapter4/></Tab.Pane>
                                <Tab.Pane eventKey={5}><Chapter5/></Tab.Pane>
                                <Tab.Pane eventKey={6}><Chapter6/></Tab.Pane>
                                <Tab.Pane eventKey={7}><Chapter7/></Tab.Pane>
                                <Tab.Pane eventKey={8}><Chapter8/></Tab.Pane>
                                <Tab.Pane eventKey={9}><Chapter9/></Tab.Pane>
                                <Tab.Pane eventKey={10}><Chapter10/></Tab.Pane>
                                <Tab.Pane eventKey={11}><Chapter11/></Tab.Pane>
                                <Tab.Pane eventKey={12}><Chapter12/></Tab.Pane>
                                <Tab.Pane eventKey={13}><Chapter13/></Tab.Pane>
                                <Tab.Pane eventKey={14}><Chapter14/></Tab.Pane>
                                <Tab.Pane eventKey={15}><Chapter15/></Tab.Pane>
                                <Tab.Pane eventKey={16}><Chapter16/></Tab.Pane>
                                <Tab.Pane eventKey={17}><Chapter17/></Tab.Pane>
                                <Tab.Pane eventKey={18}><Chapter18/></Tab.Pane>
                                <Tab.Pane eventKey={19}><Chapter19/></Tab.Pane>
                                <Tab.Pane eventKey={20}><Chapter20/></Tab.Pane>
                                <Tab.Pane eventKey={21}><Chapter21/></Tab.Pane>
                                <Tab.Pane eventKey={22}><Chapter22/></Tab.Pane>
                                <Tab.Pane eventKey={23}><Chapter23/></Tab.Pane>
                                <Tab.Pane eventKey={24}><Chapter24/></Tab.Pane>
                                <Tab.Pane eventKey={25}><Chapter25/></Tab.Pane>
                                <Tab.Pane eventKey={26}><Chapter26/></Tab.Pane>
                                <Tab.Pane eventKey={27}><Chapter27/></Tab.Pane>
                                <Tab.Pane eventKey={28}><Chapter28/></Tab.Pane>
                                <Tab.Pane eventKey={29}><Chapter29/></Tab.Pane>
                                <Tab.Pane eventKey={30}><Chapter30/></Tab.Pane>
                                <Tab.Pane eventKey={31}><Chapter31/></Tab.Pane>
                                <Tab.Pane eventKey={32}><Chapter32/></Tab.Pane>
                                <Tab.Pane eventKey={33}><Chapter33/></Tab.Pane>
                                <Tab.Pane eventKey={34}><Chapter34/></Tab.Pane>
                                <Tab.Pane eventKey={35}><Chapter35/></Tab.Pane>
                            </Tab.Content>

                            {/* Navigation Buttons */}
                            <div className="chapter-navigation">
                                <button 
                                    className="nav-btn prev-btn"
                                    onClick={handlePrevious}
                                    disabled={Number(activeKey) === 1}
                                    aria-label="Previous chapter"
                                >
                                    ← Previous
                                </button>
                                <div className="chapter-indicator">
                                    Chapter {activeKey} of {languageData.length}
                                </div>
                                <button 
                                    className="nav-btn next-btn"
                                    onClick={handleNext}
                                    disabled={Number(activeKey) === languageData.length}
                                    aria-label="Next chapter"
                                >
                                    Next →
                                </button>
                            </div>
                        </div>
                    </div>
                </Tab.Container>
            </div>
        </div>
    );
}

export default SinhalaHandBook;
